<h2 mat-dialog-title>
  <mat-icon>tune</mat-icon>
  Adjust Lessons - Enrollment #{{ data.enrollmentId }}
</h2>

<div class="lesson-adjustment-dialog">
  <mat-dialog-content>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <div class="values-section">
            <h3>Current Values</h3>
            <div class="values-grid">
              <div class="value-item">
                <span class="label">Lessons Used:</span>
                <span class="value">{{ getCurrentValue('field_lesson_used') }}</span>
              </div>
              <div class="value-item">
                <span class="label">Lessons Available:</span>
                <span class="value">{{ getCurrentValue('field_lesson_available') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-2 d-flex align-items-center justify-content-center" *ngIf="hasAnyAdjustments()">
          <div class="arrow-section">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>

        <div class="col-md-5" *ngIf="hasAnyAdjustments()">
          <div class="values-section preview-section">
            <h3>New Values</h3>
            <div class="values-grid preview-grid">
              <div class="value-item">
                <span class="label">Lessons Used:</span>
                <span class="value">{{ getPreviewValue('used') }}</span>
                <span class="change" [ngClass]="getChangeClass('used')">
                  {{ getChangeText('used') }}
                </span>
              </div>
              <div class="value-item">
                <span class="label">Lessons Available:</span>
                <span class="value">{{ getPreviewValue('available') }}</span>
                <span class="change" [ngClass]="getChangeClass('available')">
                  {{ getChangeText('available') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-section">
      <h3>Adjustments</h3>
      <form #adjustmentForm="ngForm">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="adjustment-field">
                <mat-label>Used Lessons Adjustment</mat-label>
                <input matInput
                       type="number"
                       [(ngModel)]="adjustments.used"
                       name="used_adjustment"
                       placeholder="0"
                       [min]="-9999"
                       [max]="9999">
                <mat-hint>Adjust lessons marked as used</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="adjustment-field">
                <mat-label>Available Lessons Adjustment</mat-label>
                <input matInput
                       type="number"
                       [(ngModel)]="adjustments.available"
                       name="available_adjustment"
                       placeholder="0"
                       [min]="-9999"
                       [max]="9999">
                <mat-hint>Direct adjustment to available lessons</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="adjustment-field">
                <mat-label>Reason for Adjustment</mat-label>
                <textarea matInput
                          [(ngModel)]="adjustments.notes"
                          name="adjustment_notes"
                          placeholder="Optional: Explain why you're making this adjustment"
                          rows="3">
                </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-button (click)="onReset()" *ngIf="hasAnyAdjustments()">Reset</button>
    <button mat-raised-button
            color="primary"
            (click)="onSave()"
            [disabled]="!hasAnyAdjustments() || isSaving">
      <mat-icon *ngIf="isSaving">hourglass_empty</mat-icon>
      {{ isSaving ? 'Saving...' : 'Save Adjustments' }}
    </button>
  </mat-dialog-actions>
</div>
